import React from 'react'
import { withIcon } from '../../withIcon'

function DashboardIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M11.5 21C11.5 21.5523 11.0523 22 10.5 22H3C2.44772 22 2 21.5523 2 21V13.5C2 12.9477 2.44772 12.5 3 12.5H10.5C11.0523 12.5 11.5 12.9477 11.5 13.5V21ZM14 20.5H20.5V14H14V20.5ZM3.5 20.5H10V14H3.5V20.5ZM14 10H20.5V3.5H14V10ZM3.5 10H10V3.5H3.5V10ZM22 21C22 21.5523 21.5523 22 21 22H13.5C12.9477 22 12.5 21.5523 12.5 21V13.5C12.5 12.9477 12.9477 12.5 13.5 12.5H21C21.5523 12.5 22 12.9477 22 13.5V21ZM11.5 10.5C11.5 11.0523 11.0523 11.5 10.5 11.5H3C2.44772 11.5 2 11.0523 2 10.5V3C2 2.44772 2.44772 2 3 2H10.5C11.0523 2 11.5 2.44772 11.5 3V10.5ZM22 10.5C22 11.0523 21.5523 11.5 21 11.5H13.5C12.9477 11.5 12.5 11.0523 12.5 10.5V3C12.5 2.44772 12.9477 2 13.5 2H21C21.5523 2 22 2.44772 22 3V10.5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(DashboardIcon)
